import Vue from "vue";
// eslint-disable-next-line no-unused-vars
import Vuex, { Store } from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    mbglCenter: null,
    uiRouteType: "Safe",
    uiLighting: "day",
    uiUser: "Dylan",
    mapMode: "exploreMode",
    GHParameters: [], //The POIs I'm currently working with on the map (ie regenerating their route because they just moved)
    allPOIs: [], //The master list of the markers currently on screen
    activeLayers: {
      farm: false,
      volunteer: false,
      bikeshops: false,
      museums: false,
      bars: false,
      restaurants: false,
      breweries: false,
      coffee: false
    },
    activeBaseLayers: {
      pathways: true,
      highstress: false,
      lowstress: false,
      hawks: true,
      bikelanes: false,
      theloop: false,
      satellite: false,
      annotations: false,
      streetlights: false
    },
    userLoggedInStatus: null
  },
  mutations: {
    //Mutations should never be called from components only from actions inside the store.
    //Mutations are syncronous
    //To call upon a mutation is to 'commit' a mutation
    //The only way to update state{...}
    // AddPOI(state, val) {
    //   state.POIList.push(val);
    // },
    toggleActiveBaseLayers(state, layer) {
      //read this before trying to involving watching changes to active layers -- https://github.com/vuejs/vue/issues/2164#issuecomment-377517724
      state.activeBaseLayers[layer] = !state.activeBaseLayers[layer];
    },
    loggedInStatus(state, status) {
      state.userLoggedInStatus = status;
    },
    toggleActiveLayers(state, layer) {
      state.activeLayers[layer] = !state.activeLayers[layer];
    },
    toggleSafeRouting(state) {
      state.uiRouteType = state.uiRouteType == "Safe" ? "Traditional" : "Safe";
    },
    setGHInputAfterPOIDeletion(state, val) {
      //This function is for determining what points to use to regenerate a route if a marker was deleted
      var index = state.allPOIs.indexOf(val);
      var maxIndex = state.allPOIs.length - 1;
      if (maxIndex < 1 && index == maxIndex) {
        //A single POI on screen, which was deleted -- No need to generate route
        console.log("A solo marker was deleted");
      }
      if (maxIndex >= 1 && index == 0) {
        //The 1st POI was deleted -- No need to generate route
        console.log("A first marker was deleted");
      }
      if (maxIndex >= 1 && index == maxIndex) {
        //The last POI was deleted -- No need to generate route
        console.log("A last marker was deleted");
      }
      if (maxIndex >= 1 && index > 0 && index != maxIndex) {
        //A middle POI was deleted
        console.log("A middle marker was deleted");
        state.GHParameters = [
          state.allPOIs[index - 1],
          state.allPOIs[index + 1]
        ];
      }
    },
    setGHInputAfterPOIMovement(state, val) {
      //This function is for determining what points to use to regenerate a route if a marker was moved
      var index = state.allPOIs.indexOf(val);
      var maxIndex = state.allPOIs.length - 1;
      if (maxIndex < 1 && index == maxIndex) {
        //There is only one POI on screen, which was moved -- No need to generate route
        console.log("Solo marker was moved/created");
      }
      if (maxIndex >= 1 && index == 0) {
        //The very 1st POI was moved
        console.log("First marker was moved");
        state.GHParameters = [state.allPOIs[index], state.allPOIs[index + 1]];
      }
      if (maxIndex >= 1 && index == maxIndex) {
        //The very last POI was moved
        console.log("Last marker was moved");
        state.GHParameters = [state.allPOIs[index - 1], state.allPOIs[index]];
      }
      if (maxIndex >= 1 && index > 0 && index != maxIndex) {
        //A middle POI was moved
        console.log("A middle marker was moved");
        state.GHParameters = [
          state.allPOIs[index - 1],
          state.allPOIs[index],
          state.allPOIs[index + 1]
        ];
      }
    },
    removePOI(state, val) {
      var index = state.allPOIs.indexOf(val);
      state.allPOIs.splice(index, 1);
    },
    addPOI(state, val) {
      state.allPOIs.push(val);
    },
    toggleStateFreeDrawMode(state) {
      state.mapMode =
        state.mapMode === "crosshairMode" ? "freeDrawMode" : "crosshairMode";
    },
    toggleStateMapMode(state, mode) {
      mode = mode || false;
      if (mode) {
        state.mapMode = mode;
      } else if (state.mapMode !== "crosshairMode") {
        state.mapMode = "crosshairMode";
      } else if (
        state.mapMode === "crosshairMode" ||
        state.mapMode === "freeDrawMode"
      ) {
        state.mapMode = "exploreMode";
      } else {
        alert(
          "Something is poorly coded with changing Vuex state.mapMode between 'crosshairMode', 'exploreMode', and 'freeDrawMode'"
        );
      }
    },
    toggleRouteProfile(state) {
      //I do not use this toggle yet
      state.uiRouteType = state.uiRouteType === "Safe" ? "Traditional" : "Safe";
    },
    toggleLighting(state) {
      //I do not use this toggle yet
      state.uiLighting = state.uiLighting === "day" ? "night" : "Safe";
    },
    setMbglCenter(state, val) {
      state.mbglCenter = val; //This is needed for setup of Mapbox API Library into Vue
    }
  },
  actions: {
    //Actions are asyncronous mutations -- Async functions become syncronous when you use the 'await' keyword
    //Actions 'commit' mutations
  },
  modules: {}
});
